import React from 'react';
import { Button } from 'react-bootstrap';

import { getFacebookLogin } from 'redux/actions/settingsActions';
import { useSelector } from 'react-redux';
import selectors from '../../../../selectors/selectors.js';

const FacebookIntegrationConnector = ({ platformRegistrationId, parentState = {} }) => {
  const serviceProviderId = useSelector(selectors.serviceProviderId);

  const handleClick = (e) => {
    getFacebookLogin({
      serviceProviderId,
      name: parentState.name,
      location: parentState.location,
      platformId: parentState.platformId,
    });
  };

  return (
    <>
      <div className={'section-heading'}>Connections</div>
      {!platformRegistrationId && (
        <Button variant={'primary'} onClick={handleClick}>
          Login with Facebook
        </Button>
      )}
    </>
  );
};

export default FacebookIntegrationConnector;
